<template>
  <div>
    <poster-dragger 
      :editable="editable" 
      :reason="reason" 
      @reset="resetAll"
      :dirty="dirty"
      @dirty="makeDirty">
    </poster-dragger>
  </div>
</template>
<script>

 
import { isBoss } from "@/js/store";
import { SearchUtils, is } from "@/js";
import { ArtworkTypes, ProviderAuth } from "@/gql";
import { mutateReplaceMasterPosterFrames } from '@/js/apollo'
// see below - we probably don't need this and vimeo have changed something about the links to make this fail
// import { Mimes } from "@/js/mimes";
import Posterdragger from "@/components/Posterdragger";
import { mapState, mapMutations, mapGetters } from "vuex";
import { vxMaps } from "@/js/vxstore";
// const draggable = window.vuedraggable
export default {
  beforeDestroy() {
    // save any changes made
    this.clearUp()
  },
  components: {
    "poster-dragger": Posterdragger,
  },
  props: {
    reason: Object,
    vimeoPictures: Object,
    editing: String,
    master: Object
  },
  watch: {
    vimeoPics() {
      // need this as the pics coming from vimeo can take a while so its a watch
      this.vimeoReset();
    },
    filmMaster() {
      // this needs a complete change of posterframes etc.
      this.resetAll();
    },
  },
  methods: {
    makeDirty () {
      this.dirty = this.filmMaster
    },
    clearUp() {
      // save any changes made
      if (this.dirty) {
        this.saveframes();
      }
    },

    clone(ob) {
      return ob ? JSON.parse(JSON.stringify(ob)) : null;
    },
    // generate a frames list from the thumbs - since this is a model it cant be computed
    getFramesFromThumbs(thumbs) {
      return this.clone(thumbs)
        .filter((f) => !is.nullOrUndefined(f.posterFrameOrder))
        .sort((a, b) => a.posterFrameOrder - b.posterFrameOrder);
    },
    getStoryFramesFromThumbs(thumbs) {
      return this.clone(thumbs)
        .filter((f) => !is.nullOrUndefined(f.storyFrameOrder))
        .map((f) => {
          f.defaultPosterFrame = false;
          return f;
        })
        .sort((a, b) => a.storyFrameOrder - b.storyFrameOrder);
    },
    // this is all about keeping a stack going for redo/undoemi
    resetAll() {
      this.clearUp();
      this.reset();
      this.vimeoReset();
      this.dirty = null;
    },
    // sets vimeo back to initial state
    vimeoReset() {
      const value = this.vimeoPics ? this.vimeoPics.filter((f) => f.src) : null;
      //console.log('in vmeoreset value', value, this.vimeoPics)
      this.replace({
        name: "vimeoFrames",
        value,
      });
    },
    // sets thumbnails back to initial state
    reset() {
      this.clearStack();
      let slideIndex = -1;
      let thumbnails = null;
      let frames = null;
      let storyFrames = null;
      let trash = [];
      if (this.pics) {
        thumbnails = this.clone(this.pics);
        //console.log('thumbnails', thumbnails)
        frames = this.getFramesFromThumbs(thumbnails);
        storyFrames = this.getStoryFramesFromThumbs(thumbnails);
        // if there are no frames, then the default thumbnail will be showing,
        // so we must have at least that
        if (!frames || !frames.length) {
          const def = thumbnails.find((f) => f.defaultPosterFrame);
          if (def) {
            frames = [this.clone(def)];
          }
        }
        slideIndex = frames && frames.findIndex((f) => f.defaultPosterFrame);
      }
     
      this.replace({
        name: "frames",
        value: frames,
      });
      this.replace({
        name: "thumbnails",
        value: thumbnails,
      });
      this.replace({
        name: "trash",
        value: trash,
      });
      this.replace({
        name: "storyFrames",
        value: storyFrames,
      });
      this.setSlideIndex(slideIndex);
      this.pushStack();
    },
    getDataItem(name) {
      switch (name) {
        case "frames":
          return this.frames;
        case "vimeoFrames":
          return this.vimeoFrames;
        case "thumbnails":
          return this.thumbnails;
        case "trash":
          return this.trash;
        default:
          console.log("invalid data name", name);
          return null;
      }
    },
    spliceReplaceDups(name) {
      const muri = SearchUtils.matchVimeoUri 
      const list = this.getDataItem(name);
      const undupped =
        list &&
        list.filter((f, i, a) => a.findIndex((g) => muri(g.src,f.src)) === i)
      // need to use splice to retain reactivity
      // this will shorten the list if there are any dups
      if (undupped && undupped.length !== list.length) {
        Array.prototype.splice.apply(list, [0, list.length].concat(undupped));
      }
      return list;
    },
    // sorting out default poster frame stuff
    cleanupMembers() {
      // there should be no dups, but in case there's been some problem,
      // double check and get rid of them
      ["frames", "vimeoFrames", "thumbnails", "trash"].map(
        this.spliceReplaceDups
      );

      // if we dont have a defaultposterfram, then make one
      if (this.frames && !this.frames.some((f) => f.defaultPosterFrame)) {
        // we'll just use the first one
        if (this.frames.length && this.frames[0]) {
          this.frames[0].defaultPosterFrame = true;
        }
      }
      // finally don't allow any default posterframes in thumnnails
      if (this.thumbnails) {
        this.thumbnails.forEach((f) => {
          f.defaultPosterFrame = false;
        });
      }
    },
    theSame(a, b) {
      return a && b ? JSON.stringify(a) === JSON.stringify(b) : false;
    },
    // does an apollo mutation to write the thumbnails to graphql
    saveframes() {
      // because this query does a follow up query
      // useing the filmmaster details, local cache should
      // all update magically with the new poster frames
      // without need for a special clearing
      // its the thumbnails that get written here, but the need to be tweaked with frame number
      // and we'll do that right here as nowhere else knows it
      // the mutation will take care if the item order thingie
      (this.thumbnails || []).forEach((f) => {
        // see if its also a frame
        const muri = SearchUtils.matchVimeoUri 
        const p = this.frames && this.frames.findIndex((g) => muri(g.src,f.src));
        if (p === -1) {
          f.posterFrameOrder = null;
        } else {
          f.posterFrameOrder = p * 1000 + 1000;
          f.defaultPosterFrame = this.frames[p].defaultPosterFrame;
        }
        const s =
          this.storyFrames &&
          this.storyFrames.findIndex((g) => muri(g.src === f.src));
        if (s === -1) {
          f.storyFrameOrder = null;
        } else {
          f.storyFrameOrder = s * 1000 + 1000;
        }
      });
      if (!this.editable) {
        console.log("attempt to save frames when not editing");
      } else {
        console.log(
          "wouldhave replaced",
          this.thumbnails,
          this.posterFrames.filmMaster
        );

        return mutateReplaceMasterPosterFrames({
          slides: this.thumbnails,
          filmMaster: this.dirty
        })
        
        
      }
    },
    ...mapMutations(vxMaps.mutations),
  },
  created() {
    this.resetAll();
  },
  data: () => ({
    ProviderAuth: null,
    ArtworkTypes: null,
    dirty: false,
    dirtyMaster: null
  }),
  computed: {
    film() {
      return this.reason && this.reason.Film;
    },

    filmMaster() {
      return this.master
    },

    // whether the currently logged on user is allowed to edit the current page
    permittedEditor() {
      // this is temporary till we figure out how to validate ownership of films
      return isBoss(this.ProviderAuth && this.ProviderAuth.userID);
    },
    // whether this page is editable, and for what reason
    editable() {
      // for testing turn on editing for bosses anyway
      return Boolean(this.editing || (this.permittedEditor ? "fid" : ""));
    },
    // needed to get the id of vimeoartworktyope for when this gets written away
    // TODO handle not being able to find it
    vimeoArtworkTypeID() {
      const t =
        this.ArtworkTypes &&
        this.ArtworkTypes.find((f) => f.name === "vimeo_import");
      return t && t.id;
    },
    // whether the 'pick the default frame' is lit up
    defaultFrameDisabled() {
      console.log(
        "checking defaultFrameDisabled",
        this.activeSlide,
        this.frames.length
      );
      return (
        !this.activeSlide ||
        !this.frames.length ||
        this.activeSlide.defaultPosterFrame
      );
    },

    // extract the current poster frames from the apollo set
    posterFrames() {
      const pf = SearchUtils.getPosterFramesFromMaster({
        filmMaster: this.filmMaster,
      });
     
      return pf;
    },
    posterSet() {
      return (
        this.posterFrames &&
        this.posterFrames.posterFrames &&
        this.posterFrames.posterFrames
      );
    },

    // make the baseline pics from the apollo response - this will go on to be the thumbnails set
    pics() {
      // the best will be the best quality close enough to the target aspect, worst will be the wot quality
      // TODO it might be possible to use v-img, imagmagik and sercsets here for a more fine tuned result
      const thumbnails =
        this.posterSet &&
        this.posterSet.map((f) => {
          const matches = SearchUtils.prioritizeAspectFiles({
            files: f.Artwork && f.Artwork.ArtworkToFiles,
            targetAspect: this.posterFrames.masterAspectRatio,
          });
          if (!matches.matched) {
            console.log(
              "couldnt find good enough aspect ratios at tolerance",
              matches.tolerance
            );
          }
          return {
            src: matches.worst && matches.worst.path,
            best: matches.best,
            worst: matches.worst,
            defaultPosterFrame: f.defaultPosterFrame,
            vimeoDefaultPosterFrame: false,
            type: "fid",
            artworkTypeID: f.Artwork.artworkTypeID,
            files: matches.files,
            frameNumber: f.frameNumber,
            posterFrameOrder: f.posterFrameOrder,
            storyFrameOrder: f.storyFrameOrder,
          };
        });
      return thumbnails;
    },
    // these are the baseline vimeo pics from the vimeo api
    vimeoPics() {
      const pictures = this.vimeoPictures && this.vimeoPictures.pictures;

      if (!pictures || !this.vimeoArtworkTypeID) return null;

      return pictures.map((f) => {
        // normalize files
       // console.log('vimeopics', pictures, f, f.sizes.map(o=>o.link))
        const files = f.sizes.map((o) => ({
          path: o.link,
          original: false,
          widthPx: o.width,
          heightPx: o.height,
          targetName: o.width + "x" + o.height,
          imageType: "image/jpg"  //vimeo seems to have changed to not include imagetype - don't think i need it anyway - was Mimes.getType(o.link) - we'll just use a default,
        }));
        const matches = SearchUtils.prioritizeAspectFiles({
          files,
          targetAspect: this.posterFrames.masterAspectRatio,
        });
        if (!matches.matched) {
          console.log(
            "couldnt find good enough aspect ratios at tolerance",
            matches.tolerance
          );
        }
        const src = matches.worst && matches.worst.path;
        return {
          src: src,
          best: matches.best,
          worst: matches.worst,
          defaultPosterFrame: false,
          vimeoDefaultPosterFrame: f.active,
          type: "vimeo",
          artworkTypeID: this.vimeoArtworkTypeID,
          files: matches.files,
          // because we dont know it
          frameNumber: 0,
          posterFrameOrder: null,
          storyFrameOrder: null,
        };
      });
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters),
  },
  // all apoloo defs are here
  apollo: {
    ProviderAuth: {
      query: ProviderAuth,
    },
    ArtworkTypes: {
      query: ArtworkTypes,
      variables: {
        value: "vimeo_import",
      },
    },
  },
};
</script>
